module.exports = __webpack_public_path__ + "img/qgsyt1.b1cd14c0.png";